export const shortenAddress = (address, padding = 4) => `${address.slice(0, padding)}...${address.slice(-padding)}`;
//# sourceMappingURL=utils.js.map